module.exports = __webpack_public_path__ + "img/Informationlogo.ace15eaa.jpg";